exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main-panel[data-v-13b55c4a]{max-height:100%;height:100%}", ""]);

